import { manifests as sectionPickerManifests } from './section-picker/manifests.js';

export const manifests: Array<UmbExtensionManifest> = [...sectionPickerManifests];
